<template>
  <main>
    <OrganismResetPassword/>
  </main>
</template>

<script>
export default {
  name: 'ResetPassword',

  components: {
    OrganismResetPassword: () => import('@/components/organisms/OrganismResetPassword')
  }
}
</script>
